import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
export function getMiscServiceGroups(miscServices) {
    const miscServicesGroups = new Map();
    miscServices.forEach(service => {
        var _a, _b, _c;
        if (service.type === OrderAdditionalServiceGdsServiceServiceType.Misc) {
            const miscService = service;
            const key = (_b = (_a = miscService.subtype) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : service.id;
            const servicesRfiscSet = (_c = miscServicesGroups.get(key)) !== null && _c !== void 0 ? _c : new Set();
            servicesRfiscSet.add(service.rfisc);
            miscServicesGroups.set(key, servicesRfiscSet);
        }
    });
    return [...miscServicesGroups.values()].map(servicesRfiscSet => {
        const miscServicesRfiscs = [...servicesRfiscSet];
        const isGroup = miscServicesRfiscs.length > 1;
        return {
            key: miscServicesRfiscs[0],
            filter: { param: 'rfisc', values: isGroup ? miscServicesRfiscs : [miscServicesRfiscs[0]] },
            groupServices: isGroup
                ? miscServicesRfiscs.map(rfisc => ({ filter: { param: 'rfisc', values: [rfisc] } }))
                : []
        };
    });
}
